import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer(
	"create-demean",
	() => import("../ui/friend-demean-popup"),
)
